/**
 * The piece a customer arrived with — one card, three pages.
 *
 * Contact (`?about=`), the configurator and the commission inquiry (`?from=`) all answer
 * the same question: which piece is this about. Written once because the third instance
 * is where a component earns itself, and because three near-identical cards would drift.
 * The parameter name is a data attribute so the mount decides, not this file.
 *
 * 🔴 LIQUID CANNOT READ THE QUERY STRING. Shopify does not expose it, full stop — the same
 * platform fact djh-hint-unsubscribe.js records for `?t=`. My first build of this page did
 * `all_products[about]` in the section, which is valid Liquid, renders nothing, and looks
 * exactly like a product that does not exist. It cost a push to find, because "no reference
 * card" is also the correct output for a hand-typed handle.
 *
 * ⚠️ THE HANDLE IS VALIDATED BEFORE IT IS USED IN A URL. A Shopify handle is lowercase
 * letters, digits and hyphens; anything else is not a handle and is not fetched. `?about=`
 * is attacker-controllable in the sense that anyone can send anyone a link, and the value
 * ends up in a path.
 *
 * ⚠️ IT APPENDS, NEVER OVERWRITES. Same rule as djh-commission-prefill: if the customer has
 * already typed something, theirs stays and the reference goes underneath it.
 */
(function () {
  var hosts = document.querySelectorAll('[data-djh-piece-ref]');
  if (!hosts.length) return;

  Array.prototype.forEach.call(hosts, mount);

  function mount(host) {
  var param = host.getAttribute('data-param') || 'about';

  var handle = '';
  try { handle = new URLSearchParams(window.location.search).get(param) || ''; } catch (e) { return; }
  if (!/^[a-z0-9][a-z0-9-]{0,120}$/.test(handle)) return;

  fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function (product) {
      var img = product.featured_image;
      var card = document.createElement('div');
      card.className = 'djh-piece-ref';
      card.innerHTML =
        (img ? '<img class="djh-piece-ref__img" src="" alt="" width="56" height="56" loading="lazy">' : '') +
        '<div class="djh-piece-ref__body">' +
        '<p class="djh-piece-ref__label"></p>' +
        '<a class="djh-piece-ref__link" href=""></a>' +
        '</div>';

      // Text and URLs are SET, never interpolated into the HTML above — a product title is
      // shop-authored but it travels through a JSON endpoint, and this is a form page.
      if (img) card.querySelector('img').src = img;
      card.querySelector('.djh-piece-ref__label').textContent = host.getAttribute('data-label') || '';
      var link = card.querySelector('.djh-piece-ref__link');
      link.textContent = product.title;
      link.href = '/products/' + handle;

      host.appendChild(card);
      host.hidden = false;

      // The target field differs per page and is named by the mount rather than guessed.
      var field = host.getAttribute('data-field');
      var body = field ? document.getElementById(field) : null;
      if (!body) return;
      var ref = (host.getAttribute('data-prefill') || '') + '\n' +
        product.title + '\n' + window.location.origin + '/products/' + handle;
      body.value = body.value.trim() ? body.value.trim() + '\n\n' + ref.trim() : ref.trim() + '\n\n';
    })
    .catch(function () { /* a stale or wrong handle simply shows no reference */ });
  }
})();
